import { Injectable } from '@angular/core';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {LocalStorageService} from './session.service'
import { AuditLog } from '../models';
import * as data from '../../assets/json/waterlab/userActions.json';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private rootUrl: string;
  private userAPIUrl;
  userActions: any = (data as any).default;
  constructor(private http: HttpClient,private localService:LocalStorageService) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.userAPIUrl = ApiConfig.UserApiConfig;
   }
   public setCurrentUserDetails(userDetails:string)
   {
      this.localService.setItem("userInfo",userDetails)
   }
  
	getUsers(userObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.userAPIUrl.getUsers}`, userObj )
      .pipe(
        tap(() => {
          //
        })
      );
	}
  logUserAction(objAuditLog:AuditLog)
  {
    try
    {
      let eventDescription=this.userActions.find(x=>x.key==objAuditLog.eventDescription).value
      let objUserActionParam=
        {
          LOGUSERACTION: 
          {
              "UserName":objAuditLog.userName,
              "UserAction":objAuditLog.userAction,
              "ScreenName":objAuditLog.screenName , 
              "ScreenPath":objAuditLog.screenPath,
              "Key":objAuditLog.key ,  
              "Value":objAuditLog.value ,
              "EventDescription":eventDescription,
              "EventName":objAuditLog.eventDescription
          }
        }
        this.auditLog(JSON.stringify(objUserActionParam)).subscribe(data=>{});
    }
    catch(ex)
    {
      console.log("error:"+ex)
    }
  }
  private auditLog(userActionObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.userAPIUrl.logUserAction}`, userActionObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

  validatePopupBlocker()
  {
      var isBlocked=false;
      window.resizeTo(0,0); 
      window.moveTo(0,0);
      var win1=window.open('','','width=1,height=1,left = -1000,top = -1000,z-index=-9999');
      if(win1){        
      win1.onbeforeunload=()=>{
          var win2=window.open('','','width=1,height=1,left = -1000,top = -1000,z-index=-9999');          
         if(win2==null){
          isBlocked=true;            
         }
         else{
          win2.close();           
         }
      };      
        win1.close();        
      }
      else{
        isBlocked=true;   
      }
      return isBlocked;
  }

  
  getUserHostInfo(): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.userAPIUrl.getUserHostInfo}`,null)
      .pipe(
        tap(() => {
          //
        })
      );
  }
}
